<template>
  <div>
    <div class="existing-domain">
      <div class="is-size-2">
        {{ $t('assign_domain.existing_title') }}
      </div>
      <br>
      <div class="is-size-4 has-text-weight-bold">
        {{ $t('assign_domain.step_1') }}
      </div>
      <div class="columns">
        <div class="column is-two-thirds">
          <div class="is-size-5">
            <!-- {{ $t('assign_domain.dns_instructions') }} -->
            Please click the button below to open the Domain Instructions. (Domain instructions may be different with your domain provider, please ask your current provider for help)
          </div>
          <br>
          <a
            class="button is-primary is-broad is-uppercase is-large"
            href="https://btbusiness.custhelp.com/app/answers/detail/c/5170/a_id/55208/"
            target="_blank"
          >
            <!-- {{ $t('assign_domain.dns') }} -->
            Open Domain Instructions
          </a>
        </div>
      </div>
      <br>
      <div class="is-size-4 has-text-weight-bold">
        {{ $t('assign_domain.step_2') }}
      </div>
      <div class="is-size-5">
        {{ $t('assign_domain.existing') }}
      </div>
      <div class="columns">
        <div class="column is-4">
          <input-custom
            id="existing-domain"
            v-model="domainName"
            stop-clearfix
            type="text"
            placeholder="e.g. mydomain.co.uk"
          />
          <!-- :placeholder="$t('assign_domain.existing_placeholder')" -->
        </div>
        <div class="column">
          <a
            v-if="loading"
            class="button is-primary is-broad is-uppercase is-large is-loading"
            @click="assignSiteplusDomain(domainName)"
          >
            {{ $t('common.loading_message') }}
          </a>
          <a
            v-else
            class="button is-primary is-broad is-uppercase is-large"
            @click="assignSiteplusDomain(domainName)"
          >
            {{ $t('assign_domain.button') }}
          </a>
        </div>
      </div>
      <div>
        <span
          v-if="success"
          class="is-size-5"
        >
          {{ $t('assign_domain.success_message') }}
          <router-link
            :to="{ name: 'MainSection' }"
            class="is-primary"
          >
            {{ $t('assign_domain.link') }}
          </router-link>
        </span>
        <span v-if="error"
              class="has-text-danger">
            {{ $t('common.dom_try_again') }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { SECONDS_IN_MS } from '@/helpers'
import InputCustom from '@/components/Shared/Form/InputCustom'
import siteplusMixins from '@/mixins/siteplus-generated-urls'
export default {
  name: 'ExistingDomain',

  components: {
    InputCustom
  },
  mixins: [siteplusMixins],
  data () {
    return {
      domainName: '',
      success: false,
      error: false,
      loading: false
    }
  },
  methods: {
    async assignSiteplusDomain (domainName) {
      const result = await this.assignSiteplusDomainName(domainName)

      if (result !== false) {
          this.loading = true
          this.error = false
        setTimeout(() => {
          this.success = true
          this.loading = false
        }, SECONDS_IN_MS(2))
      } else {
        this.error = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
.existing-domain {
  color: #363636;

  .button {
    margin-top: 8px;

    @media(max-width: 768px) {
      margin-top: 0px;
    }
  }
}
</style>
